import PropTypes from 'prop-types';

const propTypes = {
  targetColumn: PropTypes.string.isRequired,
  isAsc: PropTypes.bool.isRequired,
};

class Sort {
  static propTypes = propTypes;
}

export default Sort;
